import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import {
  type FetchingItemsState,
  createFetchingItemsSlice,
} from "features/Application/slices/createFetchingItemsSlice";
import { type IOwnerItemModel } from "features/People/types";

export const initialState: FetchingItemsState<IOwnerItemModel> = {
  isLoading: false,
  items: [],
  itemsCount: 0,
};

const itemsSlice = createFetchingItemsSlice({
  initialState,
  namePayload: {
    entity: ReducerEntityPrefixTypes.TemplateGroups,
    name: "Owners",
    namespace: ReducerNamespaceTypes.People,
  },
  reducers: {},
});

export const { fetchBegin, fetchFailure, fetchSuccess, reset } = itemsSlice.actions;

export default itemsSlice.reducer;
